import React from 'react';
import {Container} from 'reactstrap';

const Error404 = () =>
    <Container fluid={true}>
        <h1>Error 404</h1>
    </Container>;

export default Error404;